<template>
  <a href="#" @click.prevent="gaTrackLink(gaCategory, gaAction, data.name, url)"
    class="upcoming-post list-group-item list-group-item-action
      py-3 px-4 my-2 border border-left-0 rounded-lg
      justify-content-between d-flex align-items-start"
    style="min-height: 80px"
    :style="{'--bgColor': colorParse(data.chapterColor)}"
  >
    <div v-show="!loading" class="d-flex flex-column">
      <h5 class="font-weight-normal title-font-size">
        <i class="material-icons text-primary
        mr-2 align-bottom rotate-45" v-if="isStar">push_pin</i>
        {{ data.name }}</h5>
      <p class="text-muted mb-0 mt-auto">
        <small>{{ dateFormatYMD(data.opened_at.datetime) }}</small>
      </p>
    </div>
    <span
      class="px-md-5 px-4 py-2 rounded-lg text-nowrap tag-font-size"
      :style="{'background-color': colorParse(data.chapterColor)}"
    >{{ tag }}</span>
  </a>
</template>

<script>
export default {
  props: {
    url: String,
    data: Object,
    tag: String,
    loading: Boolean,
    isStar: Boolean,
    gaCategory: String,
    gaAction: String,
  },
  data() {
    return {};
  },
  methods: {
    colorParse(color) {
      if (!color || color === '#FFFFFF' || color === '') {
        return '#e8eaf6';
      }
      return color;
    },
  },
};
</script>

<style scoped>
.upcoming-post {
  position: relative;
  overflow: hidden;
}
.upcoming-post::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 4px;
  background-color: var(--bgColor);
}
.tag-font-size {
  font-size: 1rem;
}
@media (max-width: 768px) {
  .tag-font-size {
    font-size: 0.75rem
  }
}
.title-font-size {
  font-size: 1.25rem;
}
@media (max-width: 768px) {
  .title-font-size {
    font-size: 1rem;
  }
}
.rotate-45 {
  transform: rotate(-45deg);
}
</style>
